import { gql } from '@apollo/client'
import { useSearch, useSort } from '@btime/react-contexts'
import React from 'react'

import { stocksClient } from '../../../../utils/apollo/api'
import { usePaginatedQuery } from '../../../../utils/apollo/_helpers/pagination'
import LazyAction from '../../../../components/helpers/LazyAction'
import StatePresenter from '../../../../components/helpers/StatePresenter'

const Context = React.createContext()
const { Provider } = Context
export const useStocksState = () => React.useContext(Context) || {}
export const useStockItems = () => useStocksState()?.stockItems || []

const QUERY = gql`
  query StockItems($page: Int, $search: String, $sort: StockItemSort) {
    stockItems(page: $page, search: $search, sort: $sort) {
      id
      name
      amount
      totalAmount
      warningAmount
      criticalAmount
      enabled
      documents {
        id
        src
      }
    }
  }
`

const StockItemsLoader = ({ children, uncontrolledChildren }) => {
  const { field, type } = useSort()
  const search = useSearch()

  const { data, fetchMore, variables, ...state } = usePaginatedQuery(QUERY, {
    variables: { page: 1, search, sort: { field: field || 'NAME', type } },
    client: stocksClient
  })

  return (
    <Provider value={data}>
      <StatePresenter {...state} uncontrolledChildren={uncontrolledChildren}>
        {children}
        <LazyAction action={fetchMore} waiting={state.loading} />
      </StatePresenter>
    </Provider>
  )
}

export default StockItemsLoader
